<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'ShareRulezh',
})
</script>
<template>
  <div class="page">
    <header>
      <NavBar :title="lang('rule')" transparent> </NavBar>
    </header>
    <main>
      <div class="title">享受对象：</div>
      <div class="text">J&T Malaysia App会员</div>
      <div class="title">权益细则：</div>
      <div class="serial_wrap">
        <div class="serial">1.</div>
        <div class="text">
          每位会员可通过邀请好友获取积分。每推荐一名好友成为新会员，新会员必须输入推荐人所给予的推荐码，系统会分别奖励
          1,000 积分给推荐人。
        </div>
      </div>
      <div class="serial_wrap">
        <div class="serial">2.</div>
        <div class="text">
          系统将会自动发放每位新用户新人礼包。礼包内容如下：
          <div class="serial_wrap">
            <div class="serial_round"></div>
            <div class="text">1000 积分</div>
          </div>
          <div class="serial_wrap">
            <div class="serial_round"></div>
            <div class="text">一张 RM2 代金券</div>
          </div>
          <div class="serial_wrap">
            <div class="serial_round"></div>
            <div class="text">两张 RM1 代金券</div>
          </div>
          <div class="serial_wrap">
            <div class="serial_round"></div>
            <div class="text">一张 RM5 国际件代金券</div>
          </div>
        </div>
      </div>
      <div class="serial_wrap">
        <div class="serial">3.</div>
        <div class="text">
          在新用户下单付款后，系统会分别奖励有效邀请奖励至推荐人。奖励如下：
          <div class="serial_wrap">
            <div class="serial">a.</div>
            <div class="text">
              起步推荐者：
              <div class="serial_wrap">
                <div class="serial_rect"></div>
                <div class="text">500 积分</div>
              </div>
              <div class="serial_wrap">
                <div class="serial_rect"></div>
                <div class="text">一张 RM6 代金券</div>
              </div>
              <div class="serial_wrap">
                <div class="serial_rect"></div>
                <div class="text">一张 国际件代金券 RM5</div>
              </div>
            </div>
          </div>
          <div class="serial_wrap">
            <div class="serial">b.</div>
            <div class="text">
              顶级推荐者：
              <div class="serial_wrap">
                <div class="serial_rect"></div>
                <div class="text">500 积分</div>
              </div>
              <div class="serial_wrap">
                <div class="serial_rect"></div>
                <div class="text">一张 RM6 代金券</div>
              </div>
              <div class="serial_wrap">
                <div class="serial_rect"></div>
                <div class="text">一张 国际件代金券 RM5</div>
              </div>
              <div class="serial_wrap">
                <div class="serial_rect"></div>
                <div class="text">两张 次日达代金券 RM3</div>
              </div>
              <div class="serial_wrap">
                <div class="serial_rect"></div>
                <div class="text">两张 RM2 代金券</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="serial_wrap">
        <div class="serial">4.</div>
        <div class="text">
          起步推荐者是指成功邀请首4位新用户下单付款的现有会员，而顶级推荐者是指成功邀请第5位至第8位新用户下单付款的现有会员。
        </div>
      </div>
      <div class="serial_wrap">
        <div class="serial">5.</div>
        <div class="text">推荐积分奖励和优惠券奖励的上限为第8位新用户。</div>
      </div>
      <div class="serial_wrap">
        <div class="serial">6.</div>
        <div class="text">
          优惠券有效期为90天，按用户领取日或系统发放日(以较晚者为准)计算。
        </div>
      </div>
      <div class="serial_wrap">
        <div class="serial">7.</div>
        <div class="text">
          积分有效期为365天，按用户领取日或系统发放日(以较晚者为准)计算。
        </div>
      </div>
      <div class="serial_wrap">
        <div class="serial">8.</div>
        <div class="text">
          在本活动期间用户账号被J&T识别为风险账号或用户存在机器作弊、恶意刷奖等违规行为，主办方将取消活动资格，并有权撤销相关违规奖励，必要时追究法律责任。
        </div>
      </div>
      <div class="serial_wrap">
        <div class="serial">9.</div>
        <div class="text">
          如出现不可抗力或情势变更的情况（包括但不限于重大灾害事件、活动受政府机关指令需要停止举办或调整的、遭受严重网络攻击或因系统故障需要暂停举办），J&T有权暂停或取消本次活动，停止发放相关优惠福利。
        </div>
      </div>
      <div class="serial_wrap">
        <div class="serial">10.</div>
        <div class="text">
          J&T可根据本活动的实际举办情况对活动规则进行变动或调整，相关改动或调整将公布于活动页面上，并于公布时即时生效。
        </div>
      </div>
    </main>
  </div>
</template>

<script lang="ts" setup name="ShareRulezh">
import NavBar from '@/components/NavBar.vue'
import lang from '@/langs'
// import { useRouter } from 'vue-router'

// const router = useRouter()
</script>

<style lang="less" scoped>
.page {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  :deep(.van-icon-arrow-left) {
    color: #fff !important;
  }
  :deep(.van-nav-bar__title) {
    color: #fff !important;
  }
  :deep(.van-nav-bar__content) {
    background: #e92124 !important;
  }
  .header_right {
    .flex_align_center;
  }
  .right_filter {
    width: 12px;
    height: 13px;
  }
}
header {
  width: 100%;
}
main {
  flex: 1;
  overflow-y: auto;
  margin-top: 10px;
  padding: 10px;
  padding-top: 0;
}
.title {
  font-size: 17px;
  font-weight: bold;
  color: #333333;
  line-height: 17px;
  margin-top: 20px;
}
.text {
  font-size: 16px;
  color: #333333;
  line-height: 21px;
  margin-top: 6px;
}
.serial_wrap {
  display: flex;
  align-items: flex-start;
  margin-bottom: 2px;
}
.serial {
  color: #336df2;
  font-size: 16px;
  line-height: 21px;
  margin-top: 6px;
  margin-right: 6px;
}
.serial_round {
  width: 5px;
  height: 5px;
  border-radius: 3px;
  border: 1px solid #336df2;
  background: #fff;
  margin-right: 6px;
  margin-top: 13px;
}
.serial_rect {
  width: 4px;
  height: 4px;
  border: 1px solid #336df2;
  background: #336df2;
  margin-right: 6px;
  margin-top: 13px;
}
</style>
